import ResourceModal from 'app/components/ResourceModal';
import BillingExportScheduleForm from './BillingExportScheduleForm';
import ErrorModal from 'app/components/ErrorModal';
import { useState } from 'react';

const BillingExportScheduleModal = props => {
    const {
        isOpen,
        onClose,
        onFormSubmit,
        exportSched
    } = props;

    const [error, setError] = useState(null);

    let title, subTitle = null;

    if (exportSched) {
        title = exportSched.export_name;
    } else {
        title = 'New Billing Export Schedule';
    }

    const action = exportSched ? 'update' : 'create';

    const onSubmit = params => onFormSubmit(action, params);

    return (
        <div>
            <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
                <BillingExportScheduleForm {...{ exportSched, action, onClose, onSubmit }} />
            </ResourceModal>
            <ErrorModal error={error} onClose={() => setError(null)} />
        </div>
    );
}

export default BillingExportScheduleModal;